import {
	Component,
	ElementRef,
	Inject,
	OnInit,
	ViewChild,
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { ApiService } from "../api-service.service";
import { ActivatedRoute } from "@angular/router";
import { HelperService } from "../helper.service";

@Component({
	selector: "app-share",
	templateUrl: "./share.component.html",
	styleUrls: ["./share.component.scss"],
})
export class ShareComponent implements OnInit {
	share_link_base = "";

	@ViewChild("linkInput", { static: true })
	link_input: ElementRef<HTMLInputElement> | undefined;

	public export_id = 0;
	public report_id = 0;

	loading = true;

	public copy_text = "Copy";

	public title = "";
	public content = "";

	public export_title = "";

	constructor(
		@Inject(DOCUMENT) private document: Document,
		private api: ApiService,
		route: ActivatedRoute,
		public helper: HelperService,
	) {
		route.params.forEach((param) => {
			this.export_id = param.id;
		});
	}

	ngOnInit() {
		this.api.get_export_by_id(this.export_id).subscribe((data: any) => {
			this.share_link_base =
				this.document.location.origin + "/export/" + data.slug;
			console.log(data);
			this.title = this.helper.format_export_title(data, true, true);
			this.export_title = data.export_title;
			this.content = data.content;
			this.report_id = data.report_id;

			this.loading = false;
		});
	}

	has_share() {
		return typeof (<any>navigator).share !== "undefined";
	}

	get_mailto_url() {
		return `mailto:example@example.com?subject=${this.export_title}&body=${encodeURIComponent(this.share_link_base)}`;
	}

	get_whatsapp_url() {
		return `https://wa.me/?text=${encodeURIComponent(this.share_link_base)}`;
	}

	share_report() {
		(<any>navigator).share({
			title: this.export_title,
			text: "",
			url: this.share_link_base,
		});
	}

	copy() {
		if (this.link_input) {
			this.copy_text = "Copied!";
			this.helper.copy_value_ios(this.link_input.nativeElement.value);
		} else {
			this.copy_text = "Unable to copy";
		}
	}
}
